export const API_ENDPOINTS = {
  auth: {
    business: {
      authenticated: {
        index: '/auth/business/authenticated',
      },
      logout: {
        index: '/auth/business/logout',
      },
    },
  },
  business: {
    country: {
      index: '/business/country',
    },
    'nvc-category': {
      index: '/business/nvc-category',
    },
    v1: {
      alert: {
        index: '/business/v1/alert',
      },
      analysis: {
        case: {
          status: {
            index: '/business/v1/analysis/case/status',
          },
          type: {
            index: '/business/v1/analysis/case/type',
          },
        },
      },
      'case-extra': {
        bulletin: {
          index: '/business/v1/case-extra/bulletin',
        },
        process: {
          submit: {
            index: '/business/v1/case-extra/process/submit',
          },
        },
        'processing-time': {
          index: '/business/v1/case-extra/processing-time',
        },
        index: '/business/v1/case-extra',
      },
      case: {
        index: '/business/v1/case',

        active: {
          index: '/business/v1/case/active',
        },
        archive: {
          index: '/business/v1/case/archive',
        },
        bulk: {
          register: {
            index: '/business/v1/case/bulk/register',
          },
        },
        eoir: {
          index: '/business/v1/case/eoir',
        },
        export: {
          index: '/business/v1/case/export',
        },
        logs: {
          index: '/business/v1/case/logs',
        },
        path: {
          index: '/business/v1/case/path',
          category: {
            index: '/business/v1/case/path/category',
          },
        },
      },
      company: {
        index: '/business/v1/company',
      },
      task: {
        action: {
          index: (taskId: number) => `/business/v1/task/${taskId}/action`,
          complete: {
            index: (taskId: number) => `/business/v1/task/${taskId}/action/complete`,
          },
          history: {
            index: (taskId: number) => `/business/v1/task/${taskId}/action/history`,
          },
          actionId: {
            index: (taskId: number, actionId: number) => `/business/v1/task/${taskId}/action/${actionId}`,
          },
        },
        complete: {
          index: '/business/v1/task/complete',
        },
        filters: {
          index: '/business/v1/task/filters',
        },
        search: {
          index: '/business/v1/task/search',
        },
      },
      user: {
        index: '/business/v1/user',
        members: {
          index: '/business/v1/user/members',
          pending: {
            index: '/business/v1/user/members/pending',
          },
        },
        invite: {
          index: '/business/v1/user/invite',
        },
        withdraw: {
          index: '/business/v1/user/withdraw',
        },
      },
    },
    v2: {
      applicant: {
        index: '/business/v2/applicant',
        filters: {
          index: '/business/v2/applicant/filters',
        },
        search: {
          index: '/business/v2/applicant/search',
        },
      },
      case: {
        index: '/business/v2/case',
        filters: {
          index: '/business/v2/case/filters',
        },
        register: {
          index: '/business/v2/case/register',
        },
      },
      user: {
        index: '/business/v2/user',
        password: {
          update: {
            index: '/business/v2/user/password/update',
          },
        },
      },
    },
    v3: {
      'case-extra': {
        index: '/business/v3/case-extra',
      },
    },
    v4: {
      case: {
        search: {
          index: '/business/v4/case/search',
        },
      },
    },
  },
  case: {
    public: {
      trend: {
        'processing-time': {
          index: '/case/public/trend/processing-time',
          'optional-list': {
            index: '/case/public/trend/processing-time/optional-list',
          },
        },
        'visa-bulletin': {
          index: '/case/public/trend/visa-bulletin',
        },
      },
    },
  },
  'case-dashboard': {
    v1: {
      portal: {
        'eoir-cases': {
          index: '/case-dashboard/v1/portal/eoir-cases',
        },
        cases: {
          index: '/case-dashboard/v1/portal/cases',
        },
        options: {
          index: '/case-dashboard/v1/portal/options',
        },
        'relevant-case': {
          index: '/case-dashboard/v1/portal/relevant-case',
        },
      },
    },
    v3: {
      index: '/case-dashboard/v3',
    },
    eoir: {
      index: '/case-dashboard/eoir',
    },
  },
  mobile: {
    v1: {
      'nvc-cases': {
        locations: {
          index: '/mobile/v1/nvc-cases/locations',
        },
      },
    },
  },
  notification: {
    v1: {
      history: {
        filters: {
          index: '/notification/v1/history/filters',
        },
        index: '/notification/v1/history',
      },
    },
  },
  payment: {
    v1: {
      subscription: {
        stripe: {
          checkout: {
            index: '/payment/v1/subscription/stripe/checkout',
          },
          portal: {
            'lawfully-pro': {
              index: '/payment/v1/subscription/stripe/portal/lawfully-pro',
            },
          },
        },
      },
    },
  },
}
